// Components
import { Select } from "@mantine/core";
import { FormField } from "@benchmark/ui/components/atomic";

// Constants
import { PATIENT_ENGAGEMENT_STATUS_SELECT_OPTIONS } from "@benchmark/core/constants";

// Types
import type { UseFormReturnType } from "@mantine/form";

/**
 * Props for PatientEngagementStatusSection component.
 * @agentic connections
 */
type PatientEngagementStatusSectionProps = {
  form: UseFormReturnType<{
    "patient-engagement-status"?: string;
    [key: string]: unknown;
  }>;
  required?: boolean;
  showDivider?: boolean;
  description?: string;
};

/**
 * Form section for patient engagement status selection.
 * @agentic connections
 */
export const PatientEngagementStatusSection = ({
  form,
  required = false,
  showDivider = false,
  description = "Update member's engagement status",
}: PatientEngagementStatusSectionProps) => {
  return (
    <FormField
      label="Engagement Status"
      variant="section"
      showDivider={showDivider}
      required={required}
      error={form.errors["patient-engagement-status"] as string}
      description={description}
    >
      <Select
        data-testid="patient-engagement-status-select"
        placeholder="Select engagement status"
        data={PATIENT_ENGAGEMENT_STATUS_SELECT_OPTIONS}
        searchable
        clearable={false}
        allowDeselect={false}
        required={required}
        {...form.getInputProps("patient-engagement-status")}
      />
    </FormField>
  );
};
